// extracted by mini-css-extract-plugin
export default {"competitorQualities":"CompetitiveAnalysis_competitorQualities__1NUTg","rowContainer":"CompetitiveAnalysis_rowContainer__gUFWo"};